/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import withRouter from "../WithRouter";
//Packages
import axios from "axios";
import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";
import { isAuthenticatedTutor } from "./services/TutorAuth"; //import auth
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";
import ReturnButton from "../common/ReturnButton";

const ReportCardGenerate = (props) => {
  const [Participant, setParticipant] = useState("");
  const [ReportCards, setReportCards] = useState([]);
  const [GradingList, setGradingList] = useState([]);
  const [LessonType, setLessonType] = useState("");
  // Scoring
  const [Score_1, setScore_1] = useState("");
  const [Score_2, setScore_2] = useState("");
  const [Score_3, setScore_3] = useState("");
  const [Score_4, setScore_4] = useState("");
  const [Score_5, setScore_5] = useState("");
  const [Score_6, setScore_6] = useState("");
  const [Score_7, setScore_7] = useState("");
  const [Score_8, setScore_8] = useState("");
  const [Score_9, setScore_9] = useState("");
  const [Score_10, setScore_10] = useState("");
  const [Score_11, setScore_11] = useState("");
  const [Score_12, setScore_12] = useState("");
  // Handle Clicks, Submits, Errors
  const [submitClicked, setSubmitClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // Get the initial data
  const participantid = props.params.participantid;
  const classid = props.params.classid;
  const type = props.params.type;
  const prevParticipantid = useRef(); //Reference the previous ID to ensure new get request if it changes.
  const prevClassid = useRef(); //Reference the previous ID to ensure new get request if it changes.
  // Get the class data and set it
  useEffect(async () => {
    prevParticipantid.current = participantid; // Assign Refs Value to current load
    prevClassid.current = classid;
    // Get the Participant Data
    const getParticipantData = await axios.get(
      `/api/tutor/report_cards/participant_report/${participantid}`,
      {
        withCredentials: true,
      }
    );
    // Get the class data
    const getClassData = await axios.get(`/api/tutor/report_cards/${type}/class_session/${classid}`, {
      withCredentials: true,
    });
    setReportCards(getParticipantData.data.ReportCards);
    setLessonType(getClassData.data.LessonType);
    setGradingList(getClassData.data.GradingList);
    return setParticipant(getParticipantData.data);
  }, [participantid, classid]); // Run useEffect when the id changes to get new data.

  // Fetch new Data when circumstances require
  const fetchNewData = async () => {
    // Get the Participant Data
    const getParticipantData = await axios.get(
      `/api/tutor/report_cards/participant_report/${participantid}`,
      {
        withCredentials: true,
      }
    );
    setReportCards(getParticipantData.data.ReportCards);
    return setParticipant(getParticipantData.data);
  };

  // Handle score states
  const setScore = (index, value) => {
    if (index === 0) {
      return setScore_1(value);
    }
    if (index === 1) {
      return setScore_2(value);
    }
    if (index === 2) {
      return setScore_3(value);
    }
    if (index === 3) {
      return setScore_4(value);
    }
    if (index === 4) {
      return setScore_5(value);
    }
    if (index === 5) {
      return setScore_6(value);
    }
    if (index === 6) {
      return setScore_7(value);
    }
    if (index === 7) {
      return setScore_8(value);
    }
    if (index === 8) {
      return setScore_9(value);
    }
    if (index === 9) {
      return setScore_10(value);
    }
    if (index === 10) {
      return setScore_11(value);
    }
    if (index === 11) {
      return setScore_12(value);
    }
  };

  // Submit the Report Card
  const reportCardSubmit = async (e) => {
    e.preventDefault();
    setSubmitClicked(true);
    const data = {
      Score_1,
      Score_2,
      Score_3,
      Score_4,
      Score_5,
      Score_6,
      Score_7,
      Score_8,
      Score_9,
      Score_10,
      Score_11,
      Score_12,
      ParticipantID: participantid,
      LessonType,
      GradingList,
    };
    
    const reportCardCreation = await axios.post(`/api/tutor/report_cards/create/`, data, {
      withCredentials: true,
    });
    if (reportCardCreation.status === 200) {
      setSubmitClicked(false);
      setSuccessMessage("Successfully saved progress report.");
      return fetchNewData();
    } else {
      setSubmitClicked(false);
      return setErrorMessage("There was a problem with your request.");
    }
  };

  // Delete Report Card
  const deleteReport = async (_id, e) => {
    e.preventDefault();
    const deleteReportCard = await axios.delete(
      `/api/tutor/report_cards/delete/`,
      { data: { ParticipantID: participantid, ReportCardID: _id } },
      {
        withCredentials: true,
      }
    );
    if (deleteReportCard.status === 200) {
      setSubmitClicked(false);
      setSuccessMessage("Successfully deleted progress report.");
      return fetchNewData();
    } else {
      setSubmitClicked(false);
      return setErrorMessage("There was a problem with your request.");
    }
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };
  return (
    <div className='ReportCardGenerate'>
      <FadeIn delay={250} duration={450}>
        {isAuthenticatedTutor() ? (
          <Container className='text-center'>
            <Row>
              <Col>
                <h1>Progress for: {Participant.First_Name + " " + Participant.Last_Name}</h1>
                <ReturnButton/>
              </Col>
            </Row>
            <div className='border'>
              <Row>
                <Col sm='12'>
                  <h3>New Card</h3>
                  <p>Issue a new progress report for lesson type: {LessonType}.</p>
                </Col>
              </Row>
              <Row>
                <Col sm='12'>
                  <Form onSubmit={reportCardSubmit}>
                    {GradingList.map((item, index) => (
                      <div key={index} className='mx-1 mt-3 p-2 shadow text-center border'>
                        <h3>{item}</h3>
                        <Form.Control
                          as='select'
                          onChange={(e) => setScore(index, e.target.value)}
                          required
                          custom
                        >
                          <option value='' defaultValue>
                            Select your option
                          </option>
                          <option value='Started'>Started</option>
                          <option value='Good'>Good</option>
                          <option value='Fair'>Fair</option>
                          <option value='Excellent'>Excellent</option>
                        </Form.Control>
                      </div>
                    ))}
                    <Button
                      variant='primary'
                      className='w-100 mt-3 mb-3'
                      type='submit'
                      disabled={submitClicked}
                    >
                      Save
                    </Button>
                  </Form>
                </Col>
              </Row>
            </div>
            <Row>
              <Col sm='12'>
                <div>
                  <StatusBlock
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    dismissMessages={dismissMessages}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3>Previous Report Cards</h3>
                <p>
                  These are all report cards for this participant, and are not specifically from
                  this class type.
                </p>
                <Table striped bordered hover responsive className='text-center mb-4'>
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Date</th>
                      <th>View</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ReportCards.map((ReportCard) => (
                      <tr key={ReportCard._id}>
                        <td>
                          <small>{ReportCard.LessonType}</small>
                        </td>
                        <td>
                          <small>{ReportCard.DateIssued}</small>
                        </td>
                        <td>
                          <Button
                            size='sm'
                            variant='info'
                            as={Link}
                            type='link'
                            to={`/tutor/reportcardsview/${ReportCard._id}/`}
                          >
                            View
                          </Button>
                        </td>
                        <td>
                          <Button
                            size='sm'
                            variant='danger'
                            type='submit'
                            value={ReportCard._id}
                            onClick={(e) => deleteReport(ReportCard._id, e)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};

export default withRouter(ReportCardGenerate);
